module.exports = __webpack_public_path__ + "img/daily.a869bb2f.svg";